export default __webpack_public_path__ + "static/media/set_3_Page-2.d55a0f2d.svg";